import { computed, Injectable, Signal } from "@angular/core";
import { MissionModel } from "@m481/mp-sdk-ng";
import { Observable } from "rxjs";

import { AppConstants } from "@mp/app.constants";
import { MissionEntity, MissionEntityHelper } from "@mp/common/entities/mission.entity";
import { IListDataResponse } from "@m481/mp-sdk-ng/lib/models/reponses/list-data.response";
import { BaseStoreService } from "./base-store.service";

@Injectable({
    providedIn: "root"
})
export class MissionStoreService extends BaseStoreService<MissionEntity, MissionModel> {
    constructor() {
        super({
            storageKey: AppConstants.StorageKeys.STORE.MISSION
        });
        this.init();
    }

    /*
     * Selectors
     */

    public selectTeamMissions(teamId: string): Signal<Array<MissionEntity>> {
        return computed(() => this.entities().filter(mission => mission.teamId === teamId && (mission.isEnabled === undefined || mission.isEnabled)));
    }

    public selectTeamArchivedMissions(teamId: string): Signal<Array<MissionEntity>> {
        return computed(() => this.entities().filter(mission => mission.teamId === teamId && mission.isEnabled !== undefined && !mission.isEnabled));
    }

    /*
     * Base store service SDK methods implementation
     */

    protected mapEntityToModel(entity: MissionEntity): MissionModel {
        return MissionEntityHelper.toModel(entity);
    }

    protected mapModelToEntity(model: MissionModel): MissionEntity {
        return MissionEntityHelper.fromModel(model);
    }

    protected sdkGet$(): Observable<IListDataResponse<MissionModel>> {
        return this.mpSdkService.getMissions();
    }

    protected sdkCreate$(model: MissionModel): Observable<MissionModel> {
        return this.mpSdkService.saveMission(model);
    }

    protected sdkUpdate$(model: MissionModel): Observable<MissionModel> {
        return this.mpSdkService.saveMission(model);
    }

    protected sdkDelete$(id: string): Observable<boolean> {
        return this.mpSdkService.deleteMission(id);
    }
}
